import { cart, total_prices } from "@core/gql-mockups/cart";
import { product_tutorials } from "@core/gql-mockups/products";
import { user_summery } from "@core/gql-mockups/user";

const { minimize_str } = require("@core/helpers/string");
export const GET_CURRENT_USER_QUERY = (custom_gql) =>
  minimize_str(`
  query {
    result: getCurrentUser ${custom_gql || user_summery}
  }
`);

export const GET_CURRENT_USER_WITH_CART_QUERY = (custom_cart_mockup) =>
  minimize_str(`
  query ($lang: String, $local_cart: localCartInput) {
    user: getCurrentUser ${user_summery}
    cart: getCartDetails(is_inquiry: 0,lang: $lang, local_cart: $local_cart) ${custom_cart_mockup || cart}
  }
`);

export const GET_CART_QUERY = (custom_cart_mockup) =>
  minimize_str(`
  query ($lang: String, $local_cart: localCartInput) {
    result: getCartDetails(is_inquiry: 0,lang: $lang, local_cart: $local_cart) ${custom_cart_mockup || cart}
  }
`);

export const GET_CART_WITH_ACL_QUERY = (custom_cart_mockup) =>
  minimize_str(`
  query ($lang: String, $local_cart: localCartInput) {
    cart: getCartDetails(is_inquiry: 0,lang: $lang, local_cart: $local_cart) ${custom_cart_mockup || cart}
    price_group: getDefaultPriceGroup {
      title
      user_group_acls
    }
  }
`);

export const GET_ACL_QUERY =
  minimize_str(`
  query {
    result: getDefaultPriceGroup {
      title
      user_group_acls
    }
  }
`);

export const GET_CART_TOTAL_PRICES_QUERY = (custom_cart_mockup) =>
  minimize_str(`
  query ($lang: String, $local_cart: localCartInput) {
    result: getCartDetails(is_inquiry: 0,lang: $lang, local_cart: $local_cart) ${custom_cart_mockup || total_prices}
  }
`);

export const GET_CURRENT_USER_TUTORIALS = minimize_str(`
  query {
    result: getUserTutorials ${product_tutorials}
  }
`);
